"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncompatibleCartClickNo = exports.IncompatibleCartClickNewCart = exports.IncompatibleCartRender = void 0;
const SHARED_PROPS = {
    'Funnel Type': 'Classic',
    'Orderpipe Version': 'New',
    'Orderpipe Test Eligible': true,
};
const IncompatibleCartRender = () => [
    'View Page',
    Object.assign(Object.assign({}, SHARED_PROPS), { 'Page Name': 'Incompatible basket popin' }),
];
exports.IncompatibleCartRender = IncompatibleCartRender;
const IncompatibleCartClickNewCart = () => [
    'Click',
    Object.assign(Object.assign({}, SHARED_PROPS), { 'Click Name': 'Incompatible basket cancellation' }),
];
exports.IncompatibleCartClickNewCart = IncompatibleCartClickNewCart;
const IncompatibleCartClickNo = () => [
    'Click',
    Object.assign(Object.assign({}, SHARED_PROPS), { 'Click Name': 'Incompatible basket validation' }),
];
exports.IncompatibleCartClickNo = IncompatibleCartClickNo;
